import { render, staticRenderFns } from "./OutpatientCharts.vue?vue&type=template&id=70129f3c&"
import script from "./OutpatientCharts.vue?vue&type=script&lang=js&"
export * from "./OutpatientCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports